var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [
          _vm._v("Add " + _vm._s(_vm._f("sentenceCase")(_vm.$starLabel))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("form", [
          _c("div", { staticClass: "panel panel-grey" }, [
            _c("div", { staticClass: "panel-body" }, [
              _c(
                "div",
                { staticClass: "form-horizontal" },
                [
                  _c("create-user", { ref: "createUser" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    this.gender_module_enabled
                      ? _c("div", { staticClass: "col-md-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group",
                              class: { "has-error": _vm.$v.gender.$error },
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "control-label col-sm-4" },
                                [_vm._v("* Gender:")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-8" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "radio radio-inline radio-primary checkbox-filter-gender",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.gender.$model,
                                          expression: "$v.gender.$model",
                                        },
                                      ],
                                      attrs: {
                                        type: "radio",
                                        name: "profile.gender",
                                        id: "gender_male",
                                        value: "male",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.$v.gender.$model,
                                          "male"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.$v.gender,
                                            "$model",
                                            "male"
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm._m(0),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "radio radio-inline radio-primary checkbox-filter-gender",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.gender.$model,
                                          expression: "$v.gender.$model",
                                        },
                                      ],
                                      attrs: {
                                        type: "radio",
                                        name: "profile.gender",
                                        id: "gender_female",
                                        value: "female",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.$v.gender.$model,
                                          "female"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.$v.gender,
                                            "$model",
                                            "female"
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm._m(1),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "radio radio-inline radio-primary checkbox-filter-gender",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.$v.gender.$model,
                                          expression: "$v.gender.$model",
                                        },
                                      ],
                                      attrs: {
                                        type: "radio",
                                        name: "profile.gender",
                                        id: "gender_other",
                                        value: "other",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.$v.gender.$model,
                                          "other"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.$v.gender,
                                            "$model",
                                            "other"
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticStyle: {
                                          "font-size": "16px",
                                          "line-height": "26px",
                                        },
                                        attrs: { for: "gender_other" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                          Other\n                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.$v.gender.$error
                                  ? _c("div", { staticClass: "help-block" }, [
                                      !_vm.$v.gender.required
                                        ? _c("span", [
                                            _vm._v("Gender is required"),
                                          ])
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    this.talent_dob_module_enabled
                      ? _c("div", { staticClass: "col-md-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group",
                              class: {
                                "has-error": _vm.$v.date_of_birth.$error,
                              },
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "control-label col-sm-4" },
                                [_vm._v("* Date of Birth:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-sm-8" },
                                [
                                  _c("flat-pickr", {
                                    staticClass: "form-control pickdate",
                                    attrs: {
                                      config: _vm.datePickerConfig,
                                      placeholder: "Please select a date",
                                      name: "date_of_birth",
                                    },
                                    model: {
                                      value: _vm.$v.date_of_birth.$model,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.$v.date_of_birth,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression: "$v.date_of_birth.$model",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.$v.date_of_birth.$error
                                    ? _c("div", { staticClass: "help-block" }, [
                                        !_vm.$v.date_of_birth.required
                                          ? _c("span", [
                                              _vm._v(
                                                "Date of birth is required"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "panel-footer" },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-sm btn-primary",
                    attrs: {
                      type: "submit",
                      click: _vm.handleAddTalentCallback,
                    },
                  },
                  [
                    _vm._v(
                      "\n              Add " +
                        _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.$vlastMode && _vm.$userIsAdmin
                  ? _c(
                      "div",
                      { staticClass: "checkbox checkbox-primary pull-right" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$v.send_activation_email.$model,
                              expression: "$v.send_activation_email.$model",
                            },
                          ],
                          attrs: {
                            type: "checkbox",
                            name: "send_activation_email",
                            id: "send_activation_email",
                          },
                          domProps: {
                            checked: Array.isArray(
                              _vm.$v.send_activation_email.$model
                            )
                              ? _vm._i(
                                  _vm.$v.send_activation_email.$model,
                                  null
                                ) > -1
                              : _vm.$v.send_activation_email.$model,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.$v.send_activation_email.$model,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.$v.send_activation_email,
                                      "$model",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.$v.send_activation_email,
                                      "$model",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(
                                  _vm.$v.send_activation_email,
                                  "$model",
                                  $$c
                                )
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { attrs: { for: "send_activation_email" } },
                          [
                            _vm._v(
                              "\n                Send Activation Email To " +
                                _vm._s(_vm.$starLabel) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "gender_male" } }, [
      _c("i", { staticClass: "fa fa-male" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "gender_female" } }, [
      _c("i", { staticClass: "fa fa-female" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }